import { Modal, ModalBody, ModalHeader } from 'reactstrap';
import PartnerForm from './PartnerForm';

const NewPartnerModal = ({ isOpen = false, toggle, refresh }) => {
    return (
        <Modal className="text-light" style={{minWidth: '35vw'}} centered isOpen={isOpen} toggle={toggle}>
            <ModalHeader>New Partner</ModalHeader>
            <ModalBody>
                <PartnerForm toggle={toggle} refresh={refresh} isNew />
            </ModalBody>
        </Modal>
    );
};

export default NewPartnerModal;
